var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0134 12.4772H16.5379C15.9528 12.4772 15.4785 12.9515 15.4785 13.5366V26.2497C15.4785 26.8349 15.9528 27.3092 16.5379 27.3092H25.0134C25.5985 27.3092 26.0728 26.8349 26.0728 26.2497V13.5366C26.0728 12.9515 25.5985 12.4772 25.0134 12.4772Z",
    stroke: "#8F8F8F",
    strokeWidth: 1.854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0134 1.00012H16.5379C15.9528 1.00012 15.4785 1.47444 15.4785 2.05955V6.31845C15.4785 6.90356 15.9528 7.37788 16.5379 7.37788H25.0134C25.5985 7.37788 26.0728 6.90356 26.0728 6.31845V2.05955C26.0728 1.47444 25.5985 1.00012 25.0134 1.00012Z",
    stroke: "#8F8F8F",
    strokeWidth: 1.854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5349 1H2.05943C1.47432 1 1 1.47432 1 2.05943V14.7726C1 15.3577 1.47432 15.832 2.05943 15.832H10.5349C11.12 15.832 11.5943 15.3577 11.5943 14.7726V2.05943C11.5943 1.47432 11.12 1 10.5349 1Z",
    stroke: "#8F8F8F",
    strokeWidth: 1.854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5349 20.9312H2.05943C1.47432 20.9312 1 21.4055 1 21.9906V26.2495C1 26.8347 1.47432 27.309 2.05943 27.309H10.5349C11.12 27.309 11.5943 26.8347 11.5943 26.2495V21.9906C11.5943 21.4055 11.12 20.9312 10.5349 20.9312Z",
    stroke: "#8F8F8F",
    strokeWidth: 1.854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconDark);
export default __webpack_public_path__ + "static/media/DashboardIconDark.0d022c928b80631702e8d46f9aa066ae.svg";
export { ForwardRef as ReactComponent };